import React from 'react';
import { orderBy } from 'lodash';
import { UNKNOWN } from '@utils/constants';
import { EActionKey, EmptyArray, dimensionRequestDuration } from './constant';
import humanizeValue from '@utils/humanizeUtil';
import { MultiDimenCell } from '../cell';

export const formatRequestColumns = ({ metrics }) => {
  const columnConfig: any[] = [];

  metrics.forEach((metric) => {
    columnConfig.push({
      title: metric.displayName,
      dataKey: metric.key,
      key: metric.key,
      metric,
      resizable: true,
      width: metric.width,
      minWidth: metric.width,
      sortable: metric.sortable,
      searchable: metric.searchable,
      cellRenderer: ({ cellData, column, rowData }) => (
        <MultiDimenCell
          cellData={cellData}
          column={column}
          rowData={{ ...rowData, disableClickAction: metric.disableClickAction }}
          actionKeys={[EActionKey.copy]}
        />
      ),
    });
  });

  return columnConfig;
};

const sortRequestData = ({ data, sortBy }) => {
  const sortKey = sortBy.key;
  const unknownData = data.filter((item) => item[sortKey] === UNKNOWN);
  let validData = data.filter((item) => item[sortKey] !== UNKNOWN);

  validData = orderBy(validData, [sortBy.key], [sortBy.order]);
  return [...validData, ...unknownData];
};

export const formatRequestData = ({ data, sortBy, columnSearchData }) => {
  if (!data || data.length === 0) {
    return EmptyArray;
  }

  // 1. data into two groups: with/without trace id
  const noTraceData = data.filter((item) => item.trace_id === UNKNOWN);
  const withTraceData = data.filter((item) => item.trace_id !== UNKNOWN);

  // 2. sort
  const sortedWithTrace = sortRequestData({ data: withTraceData, sortBy });
  const sortedNoTrace = sortRequestData({ data: noTraceData, sortBy });
  let res = [...sortedWithTrace, ...sortedNoTrace];

  // 3. process duration
  res = res.map((item) => {
    if (!isNaN(Number(item[dimensionRequestDuration]))) {
      const { humanizedNumber, humanizedUnit } = humanizeValue(
        item[dimensionRequestDuration],
        '',
        'sec',
      );
      const resDuration = `${humanizedNumber} ${humanizedUnit}`;
      return {
        ...item,
        [dimensionRequestDuration]: resDuration,
      };
    }
    return item;
  });

  // 4. search
  const { key, text } = columnSearchData;
  if (key) {
    res = res.filter((item) => item[key].toLowerCase().includes(text.toLowerCase()));
  }

  return res;
};
